/**
 * A list of variables and simple functions for across our files
 */

export const variables = {
    tabletBreakpoint : 767,
    largeTabletBreakpoint: 1023,
    laptopBreakpoint: 1119,
    desktopBreakpoint: 1500,
    oversizedBreakpoint: 1700
};

export function getScreenSize() {
    return window.innerWidth;
}
